
const getNoun = (number) => {
  let result;

  if (number > 20) {
    number %= 10;
    if (number === 1) {
      result = 'товар';
    }
  }

  if (number >= 5 && number <= 20) {
    result = 'товаров';
  }

  if (number >= 2 && number <= 4) {
    result = 'товара';
  }

  if (number === 1) {
    result = 'товар';
  }

  return result;
};

const updateCartItems = (json, additional) => {
  const productList = document.querySelector('.products-wrapper');
  const fullPriceField = document.querySelector('.full-price span');
  const deliveryPriceField = document.querySelector('.delivery-price span');
  const submitButton = document.querySelector('.product-list .submit-button');
  const discountString = document.querySelector('.sale');
  const productCount = document.querySelector('.product-count');
  const minSumAlert = document.querySelector('.min-delivery-price');
  const freeDeliveryAlert = document.querySelector('.free-delivery-price');

  if (productList) {
    productList.innerHTML = '';
    const noImage = productList.dataset.noimage;

    const filteredCartItems = json.cartItems.filter((item) =>
      additional.every((sauce) => sauce.id !== item.productId),
    );

    const items = filteredCartItems.map((product) => {
      let productImageSrc = noImage;
      let productTitle = product.name;
      let productInfoText = product.name;
      let productPrice = '';
      let productGift = '';
      let buttonCount = '';

      if (product.parent && product.parent.image) {
        productImageSrc = product.parent.image;
      } else if (product.image) {
        productImageSrc = product.image;
      }

      if (product.parent) {
        productTitle = product.parent.name;
      }

      if (product.type == 'pizza' && product.isSlice) {
        productInfoText = product.name;
      } else if (product.type === 'pizza') {
        productInfoText = `${product.measureValue} ${product.measureUnit}`;
      } else if (product.type == 'treasure' || product.type == 'set') {
        productInfoText = product.description;
      }

      if (product.giftsCount !== product.quantity) {
        buttonCount = `<div class="count-button row">
          <button type="button" class="count-control minus ${product.quantity === 1 ? 'disabled' : ''}">
            <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 0V2H0V0H12Z" fill="#A3A3A3"/>
            </svg>
          </button>
          <input type="number" class="count-input base-text bold" value="${product.quantity}" />
          <button type="button" class="count-control plus ${product.quantity === 99 ? 'disabled' : ''}">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 12H5L5 0L7 8.74228e-08L7 12Z" fill="#838383"/>
              <path d="M12 5V7H0V5H12Z" fill="#838383"/>
            </svg>
          </button>
        </div>`;
        productPrice = product.totalWithoutDiscount !== 0 ? `<div>
          <span>
            ${(product.totalWithoutDiscount) / 100}
          </span> ₽
        </div>` : '';
      }

      if (product.giftsCount > 0) {
        productGift = `<div class="gift-block placeholder-text bold">Подарок ${ product.giftsCount } шт.</div>`;
      }

      return `<div class="cart-product-item ${
        !product.isAvailable ? 'unavailable' : ''
      }" data-price="${product.price}" data-id="${product.id}">
        <div class="cart-product-item-left row">
          <img src="${productImageSrc}" alt="${
        product.name
      }" class="product-image" />
          <div class="product-title base-text">
            ${productTitle}
            <div class="info desktop italic very-small-text">
              ${productInfoText}
            </div>
            ${
              !product.isAvailable
                ? '<div class="unavailable-text italic base-text">Товар временно недоступен!</div>'
                : ''
            }
          </div>
          <div class="product-controls-wrapper row mobile">
            ${buttonCount}
            <div class="product-price base-text bold">
              <div class="info mobile italic very-small-text">
                ${productInfoText}
              </div>
              ${productPrice}
              ${productGift}
            </div>
          </div>
        </div>
        <div class="cart-product-item-right row">
          <div class="product-controls-wrapper row desktop">
            ${productGift}
            ${buttonCount}
            <div class="product-price base-text bold">
              ${productPrice}
            </div>
          </div>
          <button type="button" class="delete-item" data-id="${
            product.id
          }" data-name="${product.name}" ${
        product.parent ? `data-parentname="${product.parent.name}"` : ''
      }>
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.82253 0.183533C7.70917 0.0699177 7.55526 0.00606751 7.39477 0.00606751C7.23427 0.00606751 7.08037 0.0699177 6.96701 0.183533L4 3.14448L1.03299 0.177466C0.919632 0.0638502 0.765729 0 0.605233 0C0.444737 0 0.290834 0.0638502 0.177474 0.177466C-0.0591581 0.414099 -0.0591581 0.796352 0.177474 1.03298L3.14448 4L0.177474 6.96701C-0.0591581 7.20364 -0.0591581 7.58589 0.177474 7.82253C0.414107 8.05916 0.796359 8.05916 1.03299 7.82253L4 4.85551L6.96701 7.82253C7.20364 8.05916 7.58589 8.05916 7.82253 7.82253C8.05916 7.58589 8.05916 7.20364 7.82253 6.96701L4.85552 4L7.82253 1.03298C8.05309 0.802419 8.05309 0.414099 7.82253 0.183533Z"
                fill="#A3A3A3" />
            </svg>
          </button>
        </div>
      </div>`;
    });

    productList.innerHTML = items.join('');

    if (fullPriceField) {
      fullPriceField.textContent = json.totalWithoutDiscount / 100;
    }

    if (deliveryPriceField) {
      deliveryPriceField.textContent = json.deliveryPrice ? json.deliveryPrice / 100 : 0;
    }

    if (json.type !== 'delivery') {
      minSumAlert && minSumAlert.classList.contains('visible') && minSumAlert.classList.remove('visible');
    } else if (
      json.orderable &&
      json.total >= json.deliveryMinSumTotal &&
      minSumAlert &&
      minSumAlert.classList.contains('visible')
    ) {
      minSumAlert.classList.remove('visible');

      if (!freeDeliveryAlert.classList.contains('visible')) {
        freeDeliveryAlert.classList.add('visible');
      }
    } else if (
      !json.orderable &&
      json.total < json.deliveryMinSumTotal &&
      minSumAlert &&
      !minSumAlert.classList.contains('visible')
    ) {
      if (!minSumAlert.classList.contains('visible')) {
        minSumAlert.classList.add('visible');
      }

      if (freeDeliveryAlert.classList.contains('visible')) {
        freeDeliveryAlert.classList.remove('visible');
      }
    }

    if (submitButton) {
      if (!json.orderable) {
        submitButton.classList.add('disabled');
        submitButton.setAttribute('disabled', 'disabled');
      } else {
        submitButton.classList.remove('disabled');
        submitButton.removeAttribute('disabled');
      }

      submitButton.innerHTML = `Оформить за <span data-discount="${
        json.discount / 100
      }">${json.total / 100}</span> ₽`;
    }

    if (discountString) {
      let price = (json.discount / 100).toFixed(2);

      if (price.includes('.00')) {
        price = price.replace('.00', '');
      }

      discountString.textContent = `${price} ₽`;
    }

    if (productCount) {
      productCount.textContent = `${json.quantity} ${getNoun(json.quantity)}`;
    }
  }
};

export default updateCartItems;
